import PartsPopup from "../../../../../common/AppSpecificConpnents/PartsTable/PartsPopup";
import RenderHtml from "../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml";

const PreviewPopupTable = ({ part, hidePopup }) => {
  
  return (
    <>
      <PartsPopup
        setPartsModalOpen={hidePopup}
        useTableInAuditTrail={true}
        auditTrailRow={<><tr>
          <td></td>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {part.type_name}
            </td>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {part.part_number}
            </td>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              <RenderHtml 
                content={part.description}
              />
            </td>
            <td
              style={{
            
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              <RenderHtml 
                content={part.table_note}
              />
            </td>
            <td
              style={{
              
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              <RenderHtml 
                content={part.textbox_note}
              />
            </td>
            <td
              style={{
             
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {part.default_unit_show}
            </td>
            <td
              style={{
              
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "3px",
              }}
            >
              {part.url && (
                <a
                  href={part.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
           
                    display: "inline-block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {part.url}
                </a>
              )}
            </td>
          </tr></>}
      />
    </>
  );
};

export default PreviewPopupTable;
